import { render, staticRenderFns } from "./SalesInvoiceList.vue?vue&type=template&id=506bb4b8&"
import script from "./SalesInvoiceList.vue?vue&type=script&lang=js&"
export * from "./SalesInvoiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports